import e from "./TooltipProvider_vue.js";
//#region src/components/ui/tooltip/core/TooltipProvider.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=TooltipProvider.js.map